import { appendALExamTemplate } from '@/functions/idp'
import RIC from './RIC_9'

export default appendALExamTemplate({
  ...RIC,
  aimName: 'A-level'
})
